import { gql, useQuery } from '@apollo/client';

export const QUERY = gql`
  query {
    currentOrganization {
      id
      showGettingStarted
    }
  }
`;

export const useShowGettingStarted = () => {
  const { data } = useQuery(QUERY);
  if (!data) return false;
  return data.currentOrganization.showGettingStarted;
};
